import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { HeaderPageModule } from '@components/header-page/header-page.component';

/*================================================================
# MODULES
================================================================*/
import { TranslateModule } from '@ngx-translate/core';
import { SectionModule } from '@components/section/section.component';
import { SummaryModule } from '@components/summary/summary.component';
import { AnimationsService } from '@services/animations.service';
import { RouterService } from '@shared/services/router.service';
import { environment } from '@env/environment';
import { WhatsappService } from '@services/whatsapp.service';
import { SectionServiziModule } from '@components/section-servizi/section-servizi.component';
import { SectionContattamiModule } from '@components/section-contattami/section-contattami.component';
import { ApiService } from '@shared/services/api.service';

@Component({
	selector: 'app-servizi',
	templateUrl: './servizi.component.html',
	styleUrls: ['./servizi.component.scss'],
})
export class ServiziComponent implements OnInit {
	page: any;
	background = 'assets/img/background.jpg';
	breadcrumbs: any = [{ name: 'Servizi', path: 'servizi' }];
	contactSection: any = null;

	constructor(
		public routerService: RouterService,
		public whatsappService: WhatsappService,
		private apiService: ApiService
	) {}

	/*================================================================
	# INIT
	================================================================*/
	async ngOnInit() {
		this.page = await this.apiService.post('page/page/servizi');
		if (this.page?.background) this.background = this.page?.background;

		// Set SEO
		this.routerService.setSEO({
			title: this.page.name,
			description: this.page.description,
			date: this.page.date,
			type: 'article',
		});
	}
}

/*================================================================
# MODULE
================================================================*/
@NgModule({
	declarations: [ServiziComponent],
	imports: [
		CommonModule,
		TranslateModule,
		HeaderPageModule,
		SectionModule,
		SummaryModule,
		SectionServiziModule,
		SectionContattamiModule,
	],
})
export class ServiziModule {}
